export default __webpack_public_path__ + "static/media/tab_5.36ea8227.svg";